
// ***************************************************** CATEGORY CLASS MODEL ***************************************************
export class Category {
  constructor(public id: number, 
              public vName:string, 
              public subCategories: Array<any> = [] ){ }
}


// ***************************************************** PRODUCT CLASS MODEL ****************************************************
export class Product {
  constructor(public productID: number,
              public productName: string,
              public productImagesURL: Array<any>,
              public subCategorieId: number,
              public subCategorieName: string,
              public productQuantity: number,
              public weight: number,
              public price: number,
              public isNew: boolean,
              public isHidden: boolean,
              public isInStock: boolean,
              public description: string,
              public prodInformation: string,
              public prodRecomendations: string,
              public prodRestrictions: string,
              public prodDenial: string,
              public isDiscount: boolean,
              public discountPerc: number,
              public discountTime: Array<string>,
              public cartCount: number) { }
}


// ***************************************************** BANNER CLASS MODEL ****************************************************
export class Banner {
  constructor(
    public bannerID: number,
    public bannerImageURL: string,
    public bannerImage: string,
    public bannerMainHeader: string,
    public bannerSecondaryHeader: string,
    public bannerLeadsTo: string) { }
}


// ************************************************* CATEGORY BANNER CLASS MODEL ***********************************************
export class CategoryBanner {
  constructor(
    public id: number,
    public vNumber: number,
    public image: string,
    public imageURL: string,
    public header: string,
    public leadsTo: string) { }
}

// ****************************************************** USER CLASS MODEL *****************************************************
export class User {
  constructor(
    public iUserID: number,
    public vUserName: string,
    public vEmail: string,
    public facebookId: number,
    public vPhone: number,
    public eGender: string,
    public birthdate: number,
    public ePlatform: string,
    public countryID: number,
    public provinceID: number,
    public addressIndex: number,
    public tAddress: string,
    public eStatus: string,
    public accesstoken: string,
    public currencyId: number,
    public currencyRate: number,
    public rmbDollarCurrencyRate: number) { }
}


// ****************************************************** LOGIN REQUEST CLASS MODEL *****************************************************
export class LoginRequest {
  constructor(
    public loginEmail: string,
    public loginPassword: string,
    public loginPlatform: string) { }
}


// *************************************************** REGISTRATION REQUEST CLASS MODEL *************************************************
export class RegistrationRequest {
  constructor(
    public registrationName: string,
    public registrationEmail: string,
    public registrationPassword: string,
    public registrationInvitationCode: string,
    public registrationPlatform: string) { }
}


// ******************************************************** ORDER SHORT CLASS MODEL ******************************************************
export class OrderShort {
  constructor(
    public orderID: number,
    public dtCreated: string,
    public vStatus: string,
    public stockId: string,
    public orderTotalCost: string,
    public orderTotalCostWithoutDiscount: string,
    public trackCode: string,
    public trackCodeImage: string,
    public trackCodeImageURL: string) { }
}


// ******************************************************** ORDER PAYMENT CLASS MODEL ******************************************************
export class OrderPaymentData {
  constructor(
    public orderID: number,
    public deliveryCost: string,
    public orderTotalCost: number,
    public orderTotalCostWithoutDiscount: string,
    public productsCost: string,
    public productsTotalDiscount: string,
    public rmbUsdRate: string,
    public hasDiscountCert: string,
    public hasDiscountCoupon: string,
    public discountPerc: string,
    public weight: string,
    public discountCert: DiscountCertificate,
    public discountCoupon: DiscountCoupon
  ) { }
}


// **************************************************** ORDER PAYMENT REQUEST CLASS MODEL **************************************************
export class OrderPaymentRequest {
  constructor(
    public orderId: string,
    public orderPaymentMethodType: string,
    public orderPaymentMethodId: string,
    public orderActualTotalCostAndCurrency: string,
    public rmbUserCurrencyRate: string,
    public userCurrencySign: string,
    public userCurrencyIsDecimal: string) { }
}


// *********************************************************** COUNTRY CLASS MODEL **********************************************************
export class Country {
  constructor(
    public id: number,
    public countryRus: string) { }
}


// *********************************************************** REGION CLASS MODEL *********************************************************
export class Region {
  constructor(
    public id: number,
    public regionRus: string,
    public countryID: string) { }
}


// ********************************************************** DELIVERY CLASS MODEL *********************************************************
export class Delivery {
  constructor(
    public id: number,
    public deliveryRus: string,
    public regionID: string,
    public weightGr: string,
    public price: string,
    public miniCost: string,
    public fromKg: string,
    public upToKg: string,
    public deliveryDays: string) { }
}


// **************************************************** SAVE USER DATA REQUEST CLASS MODEL ************************************************
export class SaveUserDataRequest {
  constructor(
    public userId: string,
    public userName: string,
    public userPhone: string,
    public userGender: string,
    public userBirthdate: string,
    public userCountry: string,
    public userProvince: string,
    public userIndex: string,
    public userAdress: string,
    public userCurrencyId: string) { }
}


// **************************************** SAVE USER DATA FROM ORDER FORMALIZATION PAGE REQUEST CLASS MODEL ******************************
export class SaveUserDataFromOrderFormalizationPageRequest {
  constructor(
    public userId: string,
    public userName: string,
    public userPhone: string,
    public userCountry: string,
    public userProvince: string,
    public userIndex: string,
    public userAdress: string) { }
}


// ***************************************************** DISCOUNT CERTIFICATE CLASS MODEL **************************************************
export class DiscountCertificate {
  constructor(
    public id: string,
    public certificateName: string,
    public discountPerc: string,
    public discountImageURL: string,
    public description: string,
    public endDate: string,
    public isSelected: boolean) { }
}


// ********************************************************* DISCOUNT COUPON CLASS MODEL ***************************************************
export class DiscountCoupon {
  constructor(
    public id: string,
    public couponName: string,
    public couponSum: string,
    public couponStartSum: string,
    public discountImageURL: string,
    public description: string,
    public endDate: string,
    public isSelected: boolean) { }
}


// ******************************************************** NEW ORDER REQUEST CLASS MODEL ***************************************************
export class NewOrderRequest {
  constructor(
    public userID: string,
    public platform: string,
    public receiverName: string,
    public receiverPhone: string,
    public adressCountry: string,
    public adressProvince: string,
    public adressIndex: string,
    public adressAdress: string,
    public receiverNote: string,
    public orderProductsTotalCost: string,
    public productsTotalDiscount: string,
    public orderWeight: string,
    public deliveryID: string,
    public orderDeliveryCost: string,
    public orderDeliveryDayEstimation: string,
    public orderProducts: [Map<string, string>],
    public orderTotalCost: string,
    public orderTotalCostWithoutDiscount: string,
    public rmbUsdRate: string,
    public orderDiscountCertificateId: string,
    public orderDiscountCouponId: string,
    public orderDiscountCouponSumInRMB: string,
    public orderUserCountryId: string) { }
}


// ************************************************************* NEWS POST CLASS MODEL ******************************************************
export class NewsPost {
  constructor(
    public id: number,
    public postImageURL: string,
    public postImage: string,
    public postHeader: string,
    public postText: string,
    public dtCreated: string) { }
}
